<template>
  <TransitionGroup name="pagination-effect-list">
    <div
      class="product-item"
      v-for="product in products"
      v-bind:data-product-id="product.id"
      :key="product.id"
    >
      <template v-if="showCart(product)">
        <CartTableChoiceList :showingFrom="'productListing'" />
      </template>
      <template v-else>
        <div class="product-item-info row align-items-center">
          <ProductListImage
              :product="product"
              is-from-list
              :isProductListFromParent="isProductListFromParent"
          />
          <div class="product-item-details col-sm-4">
            <h3 class="product-item-name">
              <ChoiceVanguardLabel :choice="getDefaultChoice(product)" />
            </h3>
            <div class="small-text">
              <ChoiceVanguardDescription :choice="getDefaultChoice(product)" />
            </div>
            <div class="listing-long-name">
              {{ product.longName }}
            </div>
            <div class="free-label">
              <ChoiceFreeLabel :choice="getDefaultChoice(product)" />
            </div>
            <a class="know-more" :href="product.url">
              <span>{{ $t("labels.more") }}</span>
            </a>
          </div>
          <template v-if="getDefaultChoice(product)">
            <Price
                :product="getDefaultChoice(product)"
                class="price-container col-sm-3"
            />
          </template>
          <template v-if="showaddtocart && getDefaultChoice(product)">
            <AddToCart
                :item="fillProductWithChoice(product)"
                :btnlabel="getAddToCartLabel()"
                class="col-sm-3"
            />
          </template>
          <a v-else :href="product.url" class="col-sm-2">
            <span class="goto-product">{{ $t("labels.more") }}</span>
          </a>
        </div>
      </template>
    </div>
  </TransitionGroup>
</template>

<script>
import AddToCart from "@/components/AddToCart.vue";
import Price from "@/components/productlist/subcomponents/Price.vue";
import Utils from "@/services/utils";
import Ratings from "@/components/product/Ratings.vue";
import ProductListImage from "@/components/productlist/subcomponents/Image.vue";
import ChoiceVanguardLabel from "@/components/choice/VanguardLabel.vue";
import ChoiceFreeLabel from "@/components/choice/FreeLabel.vue";
import ChoiceVanguardDescription from "@/components/choice/VanguardDescription.vue";
import { useCartStore } from '@/store/cart'
import CartTableChoiceList from '@/components/cart/table/ChoiceList.vue'
import { useUpselledStore } from '@/store/upselled'

export default {
  name: "OrderPageList",
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    categoryid: {
      type: String,
      default: "",
    },
    showaddtocart: {
      type: Boolean,
      default: true,
    },
    addToCartLabel: {
      type: String,
    },
    showprocessorder: {
      type: Boolean,
      default: false,
    },
    getDefaultChoice: {
      type: Function,
      required: true,
    },
    fillProductWithChoice: {
      type: Function,
      required: true,
    },
    isProductListFromParent: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CartTableChoiceList,
    ChoiceVanguardDescription,
    ChoiceFreeLabel,
    ChoiceVanguardLabel,
    ProductListImage,
    Ratings,
    AddToCart,
    Price,
  },
  data() {
    return {
      productDetails: null
    }
  },
  methods: {
    displayDuration(duration, startingPrice = false) {
      return Utils.displayDuration(duration, this.$i18n.locale, startingPrice);
    },
    getCart() {
      return useCartStore().cart;
    },
    showCart(product) {
      if (this.productDetails && !this.productDetails.limitCartTo1Item) {
        return false;
      }

      if (this.getCart() && this.getCart().items.length > 0) {
        const isInCart = this.getCart().items.some((item) => {
          if (item.choice.id == product.choice.id) {
            return true;
          }

          const downgradeChoice = useUpselledStore().getDowngradeChoice(item.choice);
          if (downgradeChoice && downgradeChoice.id == this.getDefaultChoice(product).id) {
            return true;
          }

          return false;
        });

        return isInCart;
      }

      return false;
    },
    getAddToCartLabel() {
      if (this.productDetails && this.productDetails.limitCartTo1Item) {
        return this.$t("labels.selectOffer");
      }

      return this.addToCartLabel;
    }
  },
  mounted() {
    this.productDetails = window.productDetails;
  },
};
</script>
